import { Controller } from "@hotwired/stimulus"

export default class HotwireApplicationController extends Controller {
  toggleScroll(event) {
    if (this.element.dataset.isMobile === "false") return

    this.element.classList.toggle("not-scrollable", event.detail.disable)
  }
}
